/* *************************************************************** *
 * THIS IS AN AUTO GENERATED FILE. PLEASE DO NOT EDIT IT DIRECTLY.
 *
 * If you want to change this Icon component , it is generated
 * from the `iconTamplate.js` file the parent directory.
 * *************************************************************** */
/* eslint-disable */
import React from 'react';
import { useFela, } from 'react-fela';
import iconStyle from '../iconStyle';
import { iconPropTypes, iconDefaultProps, } from '../iconPropTypes';

export default function IconApple({ size, fill, color, attrs, miscStyles, ...props }) {
  const className = useFela({ size, fill, color, miscStyles, }).css(iconStyle);

  return (
    <svg width="1em" height="1em" viewBox="0 0 256 256" className={className} {...props} {...attrs} data-test="IconApple">  <path fill="currentColor" d="M181.8 117.3c-.2-25.2 20.6-37.3 21.5-37.9-11.7-17.1-29.9-19.4-36.4-19.7-15.5-1.6-30.3 9.1-38.2 9.1-7.9 0-20-8.9-32.9-8.7-16.9.4-32.5 9.9-41.2 25.1-17.6 30.4-4.5 75.6 12.6 100.3 8.4 12.1 18.4 25.7 31.5 25.2 12.6-.5 17.4-8.1 32.6-8.1 15.3 0 19.5 8.1 32.9 7.9 13.6-.3 22.2-12.3 30.5-24.4 9.6-14 13.6-27.6 13.8-28.3-.3-.3-26.5-10.4-26.7-40.5m-25.1-73.9c7-8.4 11.7-20.1 10.4-31.8-10 .4-22.2 6.7-29.3 15.1-6.5 7.5-12.2 19.7-10.7 31.1 11.1.8 22.6-6 29.6-14.4" /></svg>
  );
}

IconApple.propTypes = iconPropTypes;
IconApple.defaultProps = iconDefaultProps;
